import styled from '@emotion/styled';
import { Divider } from '@material-ui/core';

const SettingsDivider = styled(Divider)({
  margin: '18px -16px'
});

export default SettingsDivider;
